import * as React from "react"
import { cn } from "../../lib/utils"

const NativeSelect = React.forwardRef(({ 
  className, 
  value, 
  onChange, 
  options = [], 
  placeholder = "Sélectionner",
  disabled = false,
  ...props 
}, ref) => {
  return (
    <select
      ref={ref}
      value={value || ""}
      onChange={(e) => onChange && onChange(e.target.value)}
      disabled={disabled}
      className={cn(
        "flex h-10 w-full rounded-md border border-slate-200 bg-white px-3 py-2 text-sm",
        "focus:outline-none focus:ring-2 focus:ring-violet-500 focus:border-violet-500",
        "disabled:cursor-not-allowed disabled:opacity-50",
        "dark:border-slate-700 dark:bg-slate-800 dark:text-white",
        "cursor-pointer",
        className
      )}
      {...props}
    >
      <option value="">{placeholder}</option>
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  )
})
NativeSelect.displayName = "NativeSelect"

export { NativeSelect }
